import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';
import AppDownload from '../../components/AppIcon/AppDownload';
import BIEASESIcon from '../../components/AppIcon/BIEASESIcon';

import './Home.css';

function Index() {
  const { t } = useTranslation();

  return (
    <div className="Home">
      <div className='banner'>
        <div className='Home-banner'>
          <BIEASESIcon/>
        </div>
      </div>
      <div className='Home-container'>
        <AppDownload/>
        <div className='footer'>
          <LanguageSwitcher />
          {t('copyright', { year: new Date().getFullYear() })}
        </div>
      </div>
    </div>
  );
}

export default Index;